import { IFormViewForm } from 'components/FormView';

const LoadPurchaseOrderForm: IFormViewForm = {
    id: 'LoadPurchaseOrderForm',
    layout: {
        rows: 1,
        columns: 1
    },
    fields: [
        {
            id: '1',
            position: {
                row: 1,
                col: 1,
                colspan: 3
            },
            type: 'PAPER_CONTAINER',
            props: {
                elevation: 0
            },
            children: [
                {
                    type: 'EX_LOOKUP_FIELD',
                    props: {
                        label: 'Load from',
                        name: 'LoadFromPurchaseOrder',
                        size: 'small',
                        lookupName: 'PurchaseOrder',
                        isLookupTypeFixed: true,
                        required: true,
                        searchScreenTitle: 'Purchase Order Lookup'
                    }
                },
                {
                    type: 'TOGGLE_FIELD',
                    props: {
                        label: 'Replace order notes and comments',
                        name: 'LoadNotesAndComments',
                        defaultValue: false,
                    }
                },
                {
                    type: 'TOGGLE_FIELD',
                    props: {
                        label: 'Replace order warehouse and delivery',
                        name: 'LoadWarehouseAndDelivery',
                        defaultValue: false,
                    }
                },
                {
                    type: 'TOGGLE_FIELD',
                    props: {
                        label: 'Append products to this order',
                        name: 'LoadProducts',
                        defaultValue: false,
                    }
                },
            ]
        }
    ]
};
export default LoadPurchaseOrderForm;
